import dayjs from "dayjs";

export const materialColumns = (navigate) => [
  {
    title: "Product Name",
    dataIndex: "productName",
    key: "productName",
  },
  {
    title: "Product Code",
    dataIndex: "productCode",
    key: "productCode",
  },
  {
    title: "Images",
    dataIndex: "images",
    key: "images",

  },
  {
    title: "Videos",
    dataIndex: "videos",
    key: "videos",
  },
  {
    title: "PDFs",
    dataIndex: "pdfs",
    key: "pdfs",
    
  },
  {
    title: "FAQs",
    dataIndex: "faqs",
    key: "faqs",
  },
  {
    title: "Date Created",
    dataIndex: "dateCreated",
    key: "dateCreated",
    render: (key) => {
      return <div>{key ? dayjs(key).format("DD/MM/YYYY") : "-"}</div>;
    },
  },
  {
    title: "Action",
    key: "action",
    render: (row) => {
      return (
        <div className="action-icons">
          <div className="grid2 d-flex">
            <button
              className="manage"
              style={{
                fontFamily: "Gotham",
                fontWeight: "400 ",
              }}
              onClick={() => {
                navigate("/ai-campaigns/manage-material", { state: row });
              }}
            >
              Manage
            </button>
          </div>
        </div>
      );
    },
  },
];
